import type { ReactNode } from 'react';
import { cn } from '../lib/cn';

export type Tone = 'neutral' | 'accent' | 'success' | 'warning' | 'danger';

export const TONE_DOT: Record<Tone, string> = {
  neutral: 'bg-line-strong',
  accent: 'bg-accent',
  success: 'bg-success',
  warning: 'bg-warning',
  danger: 'bg-danger',
};

/** Kropka koloru (7 px). Kolor niesie znaczenie, tekst obok zostaje neutralny. */
export function Dot({ tone = 'neutral', size = 7, className }: { tone?: Tone; size?: 6 | 7; className?: string }) {
  return (
    <span
      aria-hidden
      className={cn(
        'inline-block shrink-0 rounded-full',
        size === 7 ? 'size-[7px]' : 'size-1.5',
        TONE_DOT[tone],
        className,
      )}
    />
  );
}

/** Status (Figma 3017:1853): kropka 7 px + Caption w kolorze text/secondary. */
export function Status({
  tone = 'neutral',
  children,
  className,
}: {
  tone?: Tone;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn('inline-flex items-center gap-[7px] text-caption whitespace-nowrap text-fg-secondary', className)}
    >
      <Dot tone={tone} />
      {children}
    </span>
  );
}
